// Module
var code = `<button class="btn btn-primary" ng-click="\$ctrl.onRefresh()">
  Refresh ({{\$ctrl.refreshedAgo}})
</button>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/refresh-button/refresh-button.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;